<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'MiningManage'
    };
</script>

<style lang="less" scoped>
</style>
